export default {
    indicator: {
        marginTop: '15%',
        marginLeft: '45%',
    },
};
